import React, { useEffect, useState } from "react";
import { PageHeader } from "../../SharedComponents/PageHeader";

export const AttritionDetailsBI = () => {
  return (
    <div
      className="row"
      style={{
        minHeight: "calc(100vh - 2rem - 56px)",
        backgroundColor: "white",
        marginRight: 0,
        marginLeft: 0,
        alignItems: "center",
      }}
    >
      <iframe
        title="StemsAttrition"
        width="1140"
        height="541.25"
        src="https://app.powerbi.com/reportEmbed?reportId=8ba50bcc-a8c0-4f9d-9c90-5a08c8d91681&autoAuth=true&ctid=edb0e2ad-5f7b-4fcf-bbd2-7425af181ad1 "
        frameBorder="0"
        allowFullScreen
        style={{
          minHeight: "calc(100vh - 2rem - 56px)",
        }}
      ></iframe>
    </div>
  );
};
